import axios, { AxiosPromise } from 'axios';
import { EnderecoViaCep } from '../type';

export const findByCep = (cep: string): AxiosPromise<EnderecoViaCep> => {
  return axios.get(`https://viacep.com.br/ws/${cep}/json`);
};
